<script lang="ts">
    export let data: Record<string, any>
</script>

<div class="block-preview">
    <div class="imc-preview-inputs">
        <div class="imc-preview-row">
            <span class="imc-preview-label">Peso</span>
            <input type="text" class="form-control" disabled placeholder="0,00 kg" />
        </div>
        <div class="imc-preview-row">
            <span class="imc-preview-label">Altura</span>
            <input type="text" class="form-control" disabled placeholder="0 cm" />
        </div>
    </div>
    <div class="imc-preview-results">
        <div class="imc-preview-static"><span>IMC:</span><span>-</span></div>
        <div class="imc-preview-static"><span>Tipo de obesidade:</span><span>-</span></div>
        <div class="imc-preview-static"><span>Grau de risco:</span><span>-</span></div>
    </div>
</div>

<style>
    .block-preview {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .imc-preview-inputs,
    .imc-preview-results {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 24px;
    }
    .imc-preview-row {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1 1 180px;
        min-width: 160px;
    }
    .imc-preview-label {
        font-size: 0.8rem;
        color: #495057;
        width: 50px;
        flex-shrink: 0;
    }
    .form-control:disabled {
        background: #f8f9fa !important;
        border: 1px solid #e3e6ea;
        font-size: 0.9rem;
        flex: 1;
        min-width: 0;
    }
    .imc-preview-static {
        display: flex;
        flex-direction: column;
        gap: 2px;
        flex: 1 1 160px;
        min-width: 140px;
        font-size: 0.82rem;
        color: #868e96;
    }
</style>
